export const CONTEST_STATUS = {
    OPEN: 'OPEN',
    COMPLETED: 'COMPLETED',
    PENDING: 'PENDING',
    LOCKED: 'LOCKED'
};

export const PARTICIPANT_STATUS = {
    CAN_JOIN: 'CAN_JOIN',
    CAN_JOIN_QUIZ: 'CAN_JOIN_QUIZ',
    JOINED_PENDING: 'JOINED_PENDING',
    JOINED_PENDING_QUIZ: 'JOINED_PENDING_QUIZ',
    WON: 'WON',
    LOST: 'LOST',
    MISSED: 'MISSED',
    MISSED_QUIZ: 'MISSED_QUIZ',
};

export const REWARD_TYPE = {
    PHYSICAL: 'PHYSICAL',
    DISCOUNT_PERCENT: 'DISCOUNT_PERCENT',
    DISCOUNT_AMOUNT: 'DISCOUNT_AMOUNT',
    POINTS: 'POINTS'
};